'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _StarHalf = require('./StarHalf');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StarHalf).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/StarHalf/index.js
// module id = 1300
// module chunks = 1